// Default unit catalogs for the material modal's unit + shipping-unit
// fields. Unioned with units already in use on this org's materials so
// operators can pick a common label or type a custom one (native
// `<datalist>` on the form).

/** Canonical piece / inventory unit labels. */
export const DEFAULT_MATERIAL_UNITS: readonly string[] = [
  "each",
  "sheet",
  "stud",
  "piece",
  "lb",
  "ft",
  "linear ft",
  "sq ft",
  "gallon",
  "roll",
  "bag",
  "box",
];

/** How materials physically arrive (receive / weight rollups). */
export const DEFAULT_SHIPPING_UNITS: readonly string[] = [
  "each",
  "bundle",
  "pallet",
  "box",
  "case",
  "roll",
  "skid",
  "bag",
  "crate",
  "truckload",
];

function buildUnitOptions(defaults: readonly string[], existing: readonly string[]): string[] {
  const set = new Set<string>();
  for (const u of defaults) {
    const v = u.trim();
    if (v) set.add(v);
  }
  for (const u of existing) {
    const v = u.trim();
    if (v) set.add(v);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}

export function buildMaterialUnitOptions(existing: readonly string[]): string[] {
  return buildUnitOptions(DEFAULT_MATERIAL_UNITS, existing);
}

export function buildShippingUnitOptions(existing: readonly string[]): string[] {
  return buildUnitOptions(DEFAULT_SHIPPING_UNITS, existing);
}
